@if (
  {
    user: user$ | async,
    currentRole: permissionChecker.currentRole$ | async,
  };
  as vm
) {
  <!-- Desktop header -->
  <header class="hidden md:flex items-center w-full h-16 px-4 bg-white border-b border-gray-100 shadow-sm">
    <div class="flex items-center justify-between w-full mx-auto container-lg">
      <!-- Logo -->
      <img src="/logo.png" alt="handshake-business Logo" class="h-8 cursor-pointer" [routerLink]="['/']" />
      <!-- Navigation -->
      <nav *ngIf="showNav" class="flex justify-center flex-1">
        <ul class="flex gap-2 p-0 m-0 list-none">
          @for (item of navItems; track item.route) {
            <li
              *ngIf="
                item.roles?.includes(vm.currentRole) &&
                (businessForNav(vm.user)?.kycStatus === KYCStatus.ACTIVE || item.name === 'Wallets')
              ">
              <div
                class="flex items-center gap-2 px-4 py-2 transition-all duration-200 rounded-lg cursor-pointer h-9 relative hover:opacity-70"
                #rla="routerLinkActive"
                routerLinkActive
                [routerLink]="needsBeneficiarySetup && item.name !== 'Dashboard' && item.name !== 'Wallets' ? null : item.route"
                [queryParams]="needsBeneficiarySetup && item.name === 'Wallets' ? { tab: 'beneficiary' } : null"
                [class.bg-secondary]="rla.isActive"
                [class.text-primary]="rla.isActive"
                [class.text-gray-500]="!rla.isActive && !(needsBeneficiarySetup && item.name !== 'Dashboard' && item.name !== 'Wallets')"
                [class.text-gray-300]="needsBeneficiarySetup && item.name !== 'Dashboard' && item.name !== 'Wallets'"
                (click)="onNavItemClick(item)"
              >
                <span class="flex items-center justify-center">
                  <img class="w-5 h-5" [src]="rla.isActive ? item.iconActive : item.icon" [style.opacity]="needsBeneficiarySetup && item.name !== 'Dashboard' && item.name !== 'Wallets' ? '0.35' : '1'" alt="dashboard" />
                </span>
                <span class="hidden md:inline">{{ item.name }}</span>
                @if (item.name === "Updates") {
                  @if ((conversations$ | async | countUnreadMessages) > 0) {
                    <nz-badge class="absolute -top-1 -right-1" [nzCount]="conversations$ | async | countUnreadMessages" [nzSize]="'small'"></nz-badge>
                  }
                }
              </div>
            </li>
          }
        </ul>
      </nav>

      <!-- Right side icons -->
      <div class="flex items-center gap-4">
        @if (businessId && isPaymentProviderReadOverrideAllowed()) {
          <div class="flex items-center gap-2 rounded-md border border-gray-200 px-2 py-1">
            <span class="text-xs text-text-secondary">Payment provider</span>
            <nz-switch [ngModel]="paymentProviderReadsChecked" (ngModelChange)="onPaymentProviderReadsToggle($event)" />
          </div>
        }
        <!-- Notifications -->
        @if (businessId) {
          <span nz-dropdown [nzDropdownMenu]="notificationMenu" [nzPlacement]="'bottomRight'" [nzVisible]="desktopNotificationVisible" (nzVisibleChange)="desktopNotificationVisible = $event">
            <span class="relative flex items-center justify-center w-9 h-9 cursor-pointer hover:bg-gray-100 rounded-lg">
              <i nz-icon nzType="bell" class="text-xl"></i>
              @if ((unreadCount$ | async) > 0) {
                <nz-badge class="absolute -top-1 -right-1" [nzCount]="unreadCount$ | async" [nzSize]="'small'"></nz-badge>
              }
            </span>
          </span>
          <nz-dropdown-menu #notificationMenu="nzDropdownMenu">
            <div class="w-[calc(100vw-2rem)] md:w-80 bg-white rounded-lg shadow-lg border border-gray-200">
              <div class="px-4 py-3 border-b border-gray-200 bg-gray-50">
                <div class="flex items-center justify-between gap-2">
                  <h3 class="text-sm font-semibold text-gray-900">Notifications</h3>
                  @if (((unreadCount$ | async) ?? 0) > 0) {
                    <div class="flex items-center gap-2 flex-shrink-0">
                      <span class="text-xs text-gray-500">{{ unreadCount$ | async }} unread</span>
                      <button
                        type="button"
                        nz-popconfirm
                        nzPopconfirmTitle="Mark all unread notifications as read? You can still open each item from the list."
                        (nzOnConfirm)="markAllNotificationsAsReadConfirmed()"
                        [nzOkText]="'Mark all read'"
                        [nzCancelText]="'Cancel'"
                        nzPopconfirmPlacement="bottomRight"
                        class="text-xs font-medium text-blue-600 hover:text-blue-800 disabled:opacity-50 disabled:pointer-events-none"
                        [disabled]="(markAllReadInFlight$ | async) === true"
                        (click)="$event.stopPropagation()"
                      >
                        Mark all read
                      </button>
                    </div>
                  }
                </div>
              </div>
              <div class="max-h-96 overflow-y-auto">
                @if ((notifications$ | async)?.length > 0) {
                  <ul nz-menu class="!border-0">
                    @for (notification of notifications$ | async; track notification.id) {
                      <li
                        nz-menu-item
                        class="!px-4 !py-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors"
                        [class.bg-blue-50]="!notification.readAt"
                        (click)="onNotificationClick(notification.id)"
                      >
                        <div class="flex flex-col gap-1">
                          <div class="flex items-start justify-between gap-2">
                            <div class="font-medium text-sm text-gray-900 flex-1">{{ notificationTitle(notification) }}</div>
                            @if (!notification.readAt) {
                              <span class="w-2 h-2 bg-blue-500 rounded-full mt-1 flex-shrink-0"></span>
                            }
                          </div>
                          @if (notificationBody(notification); as body) {
                            <div class="text-xs text-gray-600 leading-relaxed whitespace-pre-line">{{ body }}</div>
                          }
                          <div class="text-xs text-gray-400 mt-1">{{ notification.createdAt | date: "MMM d, y, h:mm a" }}</div>
                        </div>
                      </li>
                    }
                  </ul>
                } @else {
                  <div class="p-8 text-center">
                    <i nz-icon nzType="bell" class="text-4xl text-gray-300 mb-2"></i>
                    <div class="text-sm text-gray-500">No notifications</div>
                  </div>
                }
              </div>
            </div>
          </nz-dropdown-menu>
        }
        <!-- User avatar -->
        <span nz-dropdown [nzDropdownMenu]="desktopMenu" [nzPlacement]="'bottomRight'">
          <span class="flex items-center gap-2">
            <nz-avatar nzIcon="user" [nzSrc]="vm.user?.avatar"></nz-avatar>
            <span class="hidden md:inline max-w-[150px] line-clamp-1">
              {{ ((vm.user?.firstName || "") + " " + (vm.user?.lastName || "")).trim() | truncate: 10 }}
            </span>
          </span>
        </span>
        <nz-dropdown-menu #desktopMenu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item class="w-[150px] flex items-center justify-between" (click)="profile()">
              <i nz-icon nzType="user"></i>
              Profile
            </li>
            <li nz-menu-item class="w-[150px] flex items-center justify-between" (click)="logout()">
              <i nz-icon nzType="logout"></i>
              Logout
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </div>
  </header>

  <!-- Mobile header -->
  <header class="flex items-center justify-between w-full p-4 md:hidden bg-white border-b border-gray-100">
    <div class="min-w-0 flex-1 overflow-hidden">
      <div class="text-lg font-medium text-text-primary truncate">Welcome, {{ vm.user?.firstName }}</div>
      <div class="text-xs text-text-secondary">{{ today | date: "EEEE, dd MMM yyyy" }}</div>
    </div>
    <div class="flex items-center gap-3 ml-3">
      <!-- Notifications bell -->
      @if (businessId) {
        <span nz-dropdown [nzDropdownMenu]="mobileNotificationMenu" [nzPlacement]="'bottomRight'" [nzVisible]="mobileNotificationVisible" (nzVisibleChange)="mobileNotificationVisible = $event">
          <span class="relative flex items-center justify-center w-9 h-9 cursor-pointer hover:bg-gray-100 rounded-lg">
            <i nz-icon nzType="bell" class="text-xl"></i>
            @if ((unreadCount$ | async) > 0) {
              <nz-badge class="absolute -top-1 -right-1" [nzCount]="unreadCount$ | async" [nzSize]="'small'"></nz-badge>
            }
          </span>
        </span>
        <nz-dropdown-menu #mobileNotificationMenu="nzDropdownMenu">
          <div class="w-[calc(100vw-2rem)] bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden">
            <div class="px-4 py-3 border-b border-gray-200 bg-gray-50 flex items-center justify-between gap-2">
              <h3 class="text-sm font-semibold text-gray-900">Notifications</h3>
              @if (((unreadCount$ | async) ?? 0) > 0) {
                <div class="flex items-center gap-2 flex-shrink-0">
                  <span class="text-xs text-gray-500">{{ unreadCount$ | async }} unread</span>
                  <button
                    type="button"
                    nz-popconfirm
                    nzPopconfirmTitle="Mark all unread notifications as read? You can still open each item from the list."
                    (nzOnConfirm)="markAllNotificationsAsReadConfirmed()"
                    [nzOkText]="'Mark all read'"
                    [nzCancelText]="'Cancel'"
                    nzPopconfirmPlacement="bottomRight"
                    class="text-xs font-medium text-blue-600 hover:text-blue-800 disabled:opacity-50 disabled:pointer-events-none"
                    [disabled]="(markAllReadInFlight$ | async) === true"
                    (click)="$event.stopPropagation()"
                  >
                    Mark all read
                  </button>
                </div>
              }
            </div>
            <div class="max-h-72 overflow-y-auto">
              @if ((notifications$ | async)?.length > 0) {
                <ul nz-menu class="!border-0">
                  @for (notification of notifications$ | async; track notification.id) {
                    <li
                      nz-menu-item
                      class="!px-4 !py-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors"
                      [class.bg-blue-50]="!notification.readAt"
                      (click)="onNotificationClick(notification.id)"
                    >
                      <div class="flex flex-col gap-1">
                        <div class="flex items-start justify-between gap-2">
                          <div class="font-medium text-sm text-gray-900 flex-1">{{ notificationTitle(notification) }}</div>
                          @if (!notification.readAt) {
                            <span class="w-2 h-2 bg-blue-500 rounded-full mt-1 flex-shrink-0"></span>
                          }
                        </div>
                        @if (notificationBody(notification); as body) {
                          <div class="text-xs text-gray-600 leading-relaxed whitespace-pre-line">{{ body }}</div>
                        }
                        <div class="text-xs text-gray-400 mt-1">{{ notification.createdAt | date: "MMM d, y, h:mm a" }}</div>
                      </div>
                    </li>
                  }
                </ul>
              } @else {
                <div class="p-8 text-center">
                  <i nz-icon nzType="bell" class="text-4xl text-gray-300 mb-2"></i>
                  <div class="text-sm text-gray-500">No notifications</div>
                </div>
              }
            </div>
          </div>
        </nz-dropdown-menu>
      }
      <!-- User avatar -->
      <span nz-dropdown [nzDropdownMenu]="mobileMenu" [nzPlacement]="'bottomRight'">
        <nz-avatar nzIcon="user" [nzSrc]="vm.user?.avatar"></nz-avatar>
      </span>
      <nz-dropdown-menu #mobileMenu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item class="w-[150px] flex items-center justify-between" (click)="profile()">
            <i nz-icon nzType="user"></i>
            Profile
          </li>
          <li nz-menu-item class="w-[150px] flex items-center justify-between" (click)="logout()">
            <i nz-icon nzType="logout"></i>
            Logout
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>
  </header>
}
